import { Component } from '@angular/core';
import { ActivatedRoute,Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { CommonModule } from '@angular/common';
import { HelpSupportComponent } from "../../../shared/components/help-support/help-support.component";

@Component({
  selector: 'app-customer-support',
  standalone: true,
  imports: [CommonModule, RouterModule, HelpSupportComponent],
  templateUrl: './customer-support.component.html',
  styleUrl: './customer-support.component.scss'
})
export class CustomerSupportComponent {
  environment: any = environment;
  sub:Subscription=new Subscription();

  constructor(public utils: UtilsService, private route: ActivatedRoute, private metaSvc: MetaMgmtService, private jsonDataService: JsonDataService, private router: Router) {
    this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        const activeRouter = this.utils.getActiveRouter(this.router.url);
        const metaDataFilter = res.find((x: any) => activeRouter === x.name);
        let metaData = {
          canonicalURL: metaDataFilter?.canonicalUrl || '',
          description: metaDataFilter?.description || '',
          pageTitle: metaDataFilter?.title || '',
        };
        this.metaSvc.updateMetaTags(metaData);
    },
    error: (err: any) => {
      this.utils.hideLoading()
      console.error('Error fetching meta data', err);
    }}));
    this.utils.showHeaderFooter.next(true);
  }

  ngOnDestroy() {
    
    this.sub.unsubscribe();
  }
}
